module.exports = __webpack_public_path__ + "static/media/24.319a6c18.wav";